import R from 'ramda';
import Cookies from "js-cookie";
import "whatwg-fetch";

const isJSON = contentType => (contentType === 'application/json');

function generateContentType(type) {
  const contentType = {};
  if (isJSON(type)) {
    contentType['Content-Type'] = type
  }

  return contentType;
}

export const FETCH_PARAMS = {
    credentials: 'include',
    headers: {
        'X-CSRFToken': Cookies.get('portal_csrf')
    }
};

export const getFetchParams = () => ({
    credentials: 'include',
    headers: {
        'X-CSRFToken': Cookies.get('portal_csrf'),
    },
});

function customFetchParams(method, data, contentType = 'application/json') {
    const params = getFetchParams();
    return {
        ...params,
        body: isJSON(contentType) ? JSON.stringify(data) : data,
        method: method,
        headers: {
            ...params.headers,
            'Accept': 'application/json, text/plain, */*',
            ...generateContentType(contentType)
        },
    }
}

export function FETCH_PUT_PARAMS(data, contentType) {
    return customFetchParams('PUT', data, contentType);
}

export function FETCH_POST_PARAMS(data, contentType) {
    return customFetchParams('POST', data, contentType);
}

export function FETCH_PATCH_PARAMS(data) {
    return customFetchParams('PATCH', data);
}

export function FETCH_DELETE_PARAMS() {
    return customFetchParams('DELETE');
}

export function FILE_UPLOAD_PARAMS(data) {
    return {
        ...FETCH_PARAMS,
        body: data,
        method: 'PUT',
        headers: {
            ...FETCH_PARAMS.headers,
            Accept: 'application/json, text/plain, */*',
        }
    }
}

export function FORM_METHOD(data, method) {
  const formData = new FormData();
  R.forEachObjIndexed((value, key) => formData.append(key, value), data);
    return {
        ...FETCH_PARAMS,
        body: formData,
        method: method,
        headers: {
            ...FETCH_PARAMS.headers,
            'Content-Type':'multipart/form-data',
            'Accept': 'application/json, text/plain, */*',
        }
    }
}
export function smartFetch() {
    return fetch.apply(this, arguments)
        .catch(error => {
            // Handle network errors (socket hang up, ECONNRESET, etc.)
            if (error.message === 'Failed to fetch' || error.code === 'ECONNRESET' || 
                (error.message && error.message.includes('socket hang up'))) {
                console.error('[smartFetch] Network error:', error);
                throw new Error('NETWORK_ERROR');
            }
            console.error('[smartFetch] Fetch error:', error);
            throw new Error('FETCH_ERROR');
        })
        .then(response => {
            switch (response.status) {
                case 404:
                    window.location = '/';
                    throw new Error();
                case 403:
                    return response.json().then(json => {
                        if (json.url) {
                            window.location = json.url;
                        } else {
                            // Safe fallback: redirect to login with a normalized `next` parameter.
                            // Use only the current path/query/hash, avoid nested login->login loops.
                            var loc = window.location;
                            var nextPath = loc.pathname + loc.search + loc.hash;
                            if (!nextPath || nextPath === '/' || nextPath === '#') {
                                nextPath = '/';
                            }
                            // If we are already on the login page, do not set next to login again.
                            if (/^\/login\/?(\?|#|$)/.test(nextPath)) {
                                nextPath = '/';
                            }
                            window.location = '/login/?next=' + encodeURIComponent(nextPath);
                        }
                        throw new Error();
                    });
                case 200:
                case 201:
                    return response;
            }
            throw new Error(response.status.toString());
        })
        .catch(error => {
            console.error('[smartFetch] Error:', error);
            throw error;
        })
}

export function scrollToStart() {
    $('.parallax').scrollTop($('html').height() / 3);
}

export function isEmpty(value) {
    return R.isNil(value) || R.isEmpty(value.trim());
}

export function isGreaterThanZero(value) {
    return !isEmpty(value) && parseFloat(value) > 0;
}



// WEBPACK FOOTER //
// ./src/utils.js